import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const ConfirmationColumn = ({ fulfillmentId }) => {
  const { labelFulfillment, confirmationEnumId } =
    useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const { carrierId } = labelFulfillment ?? {};
  const { confirmations } = useSelector(Global.selectReferenceDatagetAllTheCarriers)?.find((c) => c.carrierId === carrierId) ?? {};
  const confirmation = confirmations?.find((c) => parseInt(c.confirmationId, 10) === confirmationEnumId);

  return confirmation?.name ?? '';
};

ConfirmationColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Confirmation = {
  getMessageDescriptor: () => messages.confirmation,
  id: 'confirmation',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <ConfirmationColumn fulfillmentId={data.id} />;
  },
};
